
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LoadingProvider } from '@components/LoadingProvider';
import ErrorBoundary from '@components/ErrorBoundary';
import { AlertProvider } from '@components/AlertProvider';
import { AuthProvider } from './components/AuthProvider';
import { BudgetProvider } from './context/BudgetContext';

const MainLayout = lazy(() => import('./layouts/MainLayout'));
const Home = lazy(() => import('@pages/Home'));
const Budget = lazy(() => import('@pages/Budget'));
const Transactions = lazy(() => import('@pages/Transactions'));

const Reports = lazy(() => import('@pages/Reports'));
const Settings = lazy(() => import('@pages/Settings'));
const Categories = lazy(() => import('@pages/Categories'));
const BeginnerGuide = lazy(() => import('./pages/BeginnerGuide'));



const App = () => (
	<ErrorBoundary>
		<LoadingProvider>
			<AlertProvider>
				<AuthProvider>
					<BudgetProvider>
						<Router>
							<Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
								<Routes>
									<Route path="/" element={<MainLayout />}>
										<Route index element={<Home />} />
										<Route path="budget" element={<Budget />} />
										<Route path="transactions" element={<Transactions />} />
										<Route path="categories" element={<Categories />} />
										<Route path="reports" element={<Reports />} />
										<Route path="settings" element={<Settings />} />
									</Route>
									<Route path="/beginner-guide" element={<BeginnerGuide />} />
								</Routes>
							</Suspense>
						</Router>
					</BudgetProvider>
				</AuthProvider>
			</AlertProvider>
		</LoadingProvider>
	</ErrorBoundary>
);

export default App;
